import z from 'zod';

// ---------------------------------------------------------------------------
// Tower outbound — events we emit
// event.saved (tower.v1.external.events.{tenantId}.created)
// ---------------------------------------------------------------------------

export const natsRequirementSchema = z.object({
	key: z.string(),
	name: z.string().optional(),
	status: z.enum(['pending', 'inReview', 'accepted', 'expired', 'expiryWarning']).optional(),
	issues: z.array(z.string()).optional(),
});

export const natsAdminSchema = z.object({
	id: z.string(),
	firstName: z.string().optional(),
	lastName: z.string().optional(),
	email: z.string().optional(),
	phone: z.string().optional(),
});

export const natsEventDataSchema = z.object({
	id: z.string(),
	name: z.string(),
	description: z.string().optional(),
	requirements: z.array(natsRequirementSchema),
	status: z.enum(['pending', 'inReview', 'accepted', 'expired', 'expiryWarning', 'exception']),
	startTime: z.coerce.date(),
	finishTime: z.coerce.date(),
	type: z.object({
		id: z.string(),
		possibleRoles: z.array(z.object({ id: z.string(), name: z.string() })),
	}),
	admins: z.array(natsAdminSchema),
	zones: z.array(
		z.object({
			id: z.string(),
			name: z.string(),
			site: z.object({
				id: z.string(),
				name: z.string(),
				address: z.object({
					address: z.string().optional(),
					postalCode: z.string().optional(),
					city: z.string().optional(),
					country: z.string().optional(),
				}),
			}),
		}),
	),
	createdAt: z.date(),
	updatedAt: z.date(),
});

export const natsCompanyDataSchema = z.object({
	id: z.string(),
	name: z.string(),
	uniqueId: z.string(),
	requirements: z.array(natsRequirementSchema),
	admins: z.array(natsAdminSchema),
});

export const natsEventAckMessageSchema = z.object({
	event: z.literal('event.acknowledged'),
	timestamp: z.string(),
	data: z.object({
		towerId: z.string(),
		workforceJobId: z.string(),
	}),
});

export const natsEventCreatedMessageSchema = z.object({
	event: z.literal('event.saved'),
	timestamp: z.string(),
	tenant: z.object({
		id: z.string(),
		name: z.string().optional(),
		url: z.string(),
	}),
	data: z.object({
		event: natsEventDataSchema,
		company: natsCompanyDataSchema,
	}),
});
